export const OrgPermissions = {
    ORG_DASHBOARD: 'org_dashboard',
    VIRTUAL_GUARD: 'virtual_guard',
    CLOUD_VIDEO: 'cloud_video',
    LPR: 'lpr',
    RENTAL_MANAGER: 'rental_manager',
    DEVICES: 'devices',
    SETTINGS: 'settings',
    VIEW_ACCESS_LOGS: 'view_access_logs',
    MANAGE_ACCESS_CONTROL: 'manage_access_control',
    MANAGE_PROPERTIES: 'manage_properties',
    MANAGE_OCCUPANTS: 'manage_occupants',
    MANAGE_OCCUPANT_DEVICES: 'manage_occupant_devices',
    MANAGE_OCCUPANT_VEHICLES: 'manage_occupant_vehicles',
    MANAGE_OPERATORS: 'manage_operators',
    MANAGE_ORG_GUESTS: 'manage_org_guests',
    MANAGE_ORG_DEVICES: 'manage_org_devices',
    MANAGE_ORG_VEHICLES: 'manage_org_vehicles',
    MANAGE_ORG_CODES: 'manage_org_codes',
    MANAGE_GUARD_CODES: 'manage_guard_codes',
    MANAGE_ASSOCIATE_MEMBERS: 'manage_associate_members',
    MANAGE_CREDENTIAL_GRANTS: 'manage_credential_grants',
    MANAGE_REPORTS: 'manage_reports',
    SHORT_TERM_RENTAL: 'short_term_rental',
    DEVICE_ASSIGN_OCCUPANTS: 'device_assign_occupants',
    DEVICE_ASSIGN_PROPERTY_GUESTS: 'device_assign_property_guests',
    DEVICE_ASSIGN_INVITED_OCCUPANTS: 'device_assign_invited_occupants',
    DEVICE_ASSIGN_OPERATORS: 'device_assign_operators',
    DEVICE_ASSIGN_ORG_GUESTS: 'device_assign_org_guests',
    MANAGE_TRAFFIC_CITATIONS: 'manage_traffic_citations'
};

export const DetailedPermissions = [
    // Top-level module permissions
    {
        key: 'org_dashboard',
        name: 'Org Dashboard',
        description: 'Access the organization-wide dashboard for insights and analytics.',
        modules: ['org_dashboard']
    },
    {
        key: 'virtual_guard',
        name: 'Virtual Guard',
        description: 'Access the virtual guard module for monitoring and response.',
        modules: ['virtual_guard']
    },
    {
        key: 'cloud_video',
        name: 'Cloud Video',
        description: 'Access cloud video module for video management and playback.',
        modules: ['cloud_video']
    },
    {
        key: 'rental_manager',
        name: 'Rental Manager',
        description: 'Access rental manager module for handling rental operations.',
        modules: ['rental_manager']
    },
    {
        key: 'rental_manager',
        name: 'Rental Manager',
        description: 'Access rental manager module for handling rental operations.',
        modules: ['short_term_rental']
    },
    {
        key: 'lpr',
        name: 'License Plate Recognition',
        description: 'Access license plate recognition features and logs.',
        modules: ['lpr']
    },
    {
        key: 'devices',
        name: 'Devices',
        description: 'Add, configure, and manage devices within the organization.',
        modules: ['devices', 'org_dashboard']
    },
    {
        key: 'settings',
        name: 'Organization Settings',
        description: 'Access to organization settings and configurations.',
        modules: ['settings']
    },

    // Org Dashboard specific permissions
    {
        key: 'view_access_logs',
        name: 'View Access Logs',
        description: 'View access logs and entry/exit records across the organization.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_access_control',
        name: 'Manage Access Control',
        description: 'Configure and manage access control settings and permissions.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_properties',
        name: 'Manage Properties',
        description: 'Add, edit, and remove properties in the organization.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_occupants',
        name: 'Manage Occupants',
        description: 'Manage occupant accounts and access permissions.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_occupant_devices',
        name: 'Manage Occupant Devices',
        description: 'Manage devices assigned to occupants.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_occupant_vehicles',
        name: 'Manage Occupant Vehicles',
        description: 'Manage vehicles registered to occupants.',
        modules: ['org_dashboard', 'my_vehicles']
    },
    {
        key: 'manage_operators',
        name: 'Manage Operators',
        description:
            'Create, edit, and remove operator accounts within the organization.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_org_guests',
        name: 'Manage Organization Guests',
        description:
            'Manage guests for the organization, including invitations and access.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_org_devices',
        name: 'Manage Organization Devices',
        description: 'Manage devices at the organization level.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_org_vehicles',
        name: 'Manage Organization Vehicles',
        description: 'Manage vehicles registered at the organization level.',
        modules: ['org_dashboard', 'my_vehicles']
    },
    {
        key: 'manage_org_codes',
        name: 'Manage Organization Codes',
        description: 'Manage access codes for the organization.',
        modules: ['org_dashboard']
    },
    {
        key: 'manage_guard_codes',
        name: 'Manage Guard Codes',
        description: 'Manage guard access codes for the organization.',
        modules: ['guard']
    },
    {
        key: 'manage_associate_members',
        name: 'Manage Associate Members',
        description: 'Add and manage associate members on non-member properties.',
        modules: ['associate_members']
    },
    {
        key: 'manage_credential_grants',
        name: 'Manage Credential Grants',
        description:
            'Manage shared credential grants received from sponsoring organizations, including which access groups they carry.',
        modules: ['credential_sharing_consumer']
    },
    {
        key: 'manage_traffic_citations',
        name: 'Manage Traffic Citations',
        description:
            'Review TrafficLogix speeding citations, associate them with members, and issue or dismiss tickets.',
        modules: ['traffic_citations']
    },
    {
        key: 'manage_reports',
        name: 'Manage Reports',
        description:
            'Open incident reports and daily activity reports filed by guards, and act on them — acknowledge and close.',
        modules: ['guard']
    }
];

export const DefaultRoles = {
    manager: {
        key: 'manager',
        name: 'Manager',
        permissions: []
    },
    employee: {
        key: 'employee',
        name: 'Employee',
        permissions: []
    },
    virtual_guard: {
        key: 'virtual_guard',
        name: 'Virtual Guard',
        permissions: []
    },
    guard: {
        key: 'guard',
        name: 'Guard',
        permissions: []
    },
    // Org-scoped role key (orgs[orgId].type) — never promotes the root user type. Incident
    // report routing and every supervisor gate here key off orgs[orgId].type, not a permission.
    // Auto-generated alongside the Guard role when the module is on.
    supervisor: {
        key: 'supervisor',
        name: 'Supervisor',
        permissions: []
    },
    rental_manager: {
        key: 'rental_manager',
        name: 'Rental Manager',
        permissions: []
    }
};

export const ModulesNames = {
    org_dashboard: 'Dashboard',
    lpr: 'License Plates',
    // cloud_video: 'Cloud Video',
    virtual_guard: 'Virtual Guard',
    guard: 'Guard',
    short_term_rental: 'Short-Term Rental',
    rental_manager: 'Legacy Rental Manager',
    settings: 'Settings',
    devices: 'Devices',
    associate_members: 'Associate Members',
    guests: 'Guests',
    credential_sharing_sponsor: 'Credential Sharing (Sponsor)',
    credential_sharing_consumer: 'Credential Sharing (Consumer)',
    traffic_citations: 'Traffic Citations'
};

export const SubmoduleHierarchy = {
    lpr: {
        my_vehicles: 'My Vehicles'
    },
    virtual_guard: {
        ramco_virtual_guard: 'Ramco Virtual Guard'
    },
    devices: {
        device_assign_occupants: 'Occupants',
        device_assign_property_guests: 'Property Guests',
        device_assign_invited_occupants: 'Invited Occupants',
        device_assign_operators: 'Operators',
        device_assign_org_guests: 'Org Guests'
    }
};

export const DeviceAssignKeys = Object.keys(SubmoduleHierarchy.devices);

// it could be the case that we just need modules for handling routes access, but I will leave modules and permissions separated for now.
export const moduleKeys = {
    ORG_DASHBOARD: 'org_dashboard',
    SUPER_ADMIN: 'super_admin',
    RENTAL_MANAGER: 'rental_manager',
    CLOUD_VIDEO: 'cloud_video',
    VIRTUAL_GUARD: 'virtual_guard',
    RAMCO_VIRTUAL_GUARD: 'ramco_virtual_guard',
    GUARD: 'guard',
    SETTINGS: 'settings',
    DEVICES: 'devices',
    LPR: 'lpr',
    MY_VEHICLES: 'my_vehicles',
    ASSOCIATE_MEMBERS: 'associate_members',
    SHORT_TERM_RENTAL: 'short_term_rental',
    GUESTS: 'guests',
    CREDENTIAL_SHARING_SPONSOR: 'credential_sharing_sponsor',
    CREDENTIAL_SHARING_CONSUMER: 'credential_sharing_consumer',
    TRAFFIC_CITATIONS: 'traffic_citations'
};
